// 创建文件en/index.js
const TW = {
    my: "我的",
    today: "今天",
    this_week: "本周",
    this_month: "本月",
    last_month: "上月",
    this_year: "今年",
    number_of_people: "人數",
    amount: "金額",
    enter_username_id_to_search: "輸入用戶名ID查詢",
    team_list: "團隊列表",
    registration_time: "註冊時間",
    selling_face_value: "出售面值",
    click_for_details: "點擊詳情",
    "agent_login": "代理登入",
    "Agent.Center": "代理中心",
    'SignOut': '注销帳號',
    'Contact us': "聯絡我們",
    'Download our app': "下載我們的應用",
    'Download it from': "下載網址",
    'About Us': "關於我們",
    'Gobuy USA was founded in 2012': "Gobuy美國成立於2021年",
    'Customer service': "客戶服務",
    'frequently asked question': "常見問題",
    'Return and exchange policy': "退換貨政策",
    'Shipping and distribution': "配送與出貨",
    'Contact us by email': "透過郵箱聯絡我們",
    'Privacy Policy and Terms of Use': "隱私權政策和使用條款",
    'Privacy Policy': "隱私權政策",
    'Terms of use': "使用條款",
    'Upload credentials': "上傳憑證",
    'The withdrawal is being processed': "提現處理中",
    'Cause of failure': "失敗原因",
    'Your shopping cart is still empty': "您的購物車還是空的",
    'Log in to view the items in your cart': "登入查看購物車中的商品",
    'Browse around': "瀏覽一下",
    'Account correlation': "帳戶相關",
    'Order management': "訂單管理",
    'Payment method': "付款方式",
    'Collection address': "收款地址",
    Category: "分類",
    "MyCommission": "我的佣金",
    "Gross income": "總收入",
    "Direct commission": "直接佣金",
    "Indirect commission": "間接佣金",
    "Transfer to wallet": "轉入錢包",
    "Tip: The transfer amount must be greater than 10USDT": "提示：轉帳金額必須大於10USDT",
    "transfer": "轉帳",
    "commission": "佣金",
    "Please enter": "請輸入",
    "Team Commission": "團隊佣金",

    'Old Password': "舊密碼",
    'Change password': "修改密碼",
    'Gobuy GIFT CARD': "Gobuy禮品卡",
    'High Priced Recycling': "高價回收",
    'Data': "日期",
    'congratulations': "恭喜",
    'Obtain': "獲得",
    'ThankYouForParticipating': "謝謝參與",

    // navbar"",
    Home: "首頁",
    Search: "搜尋",
    ShoppingCart: "購物車",
    Mine: "我的",

    // 首页
    // 搜索
    EnterSearchContent: "輸入搜尋內容",
    'Recent searches': "最近搜尋",
    'popular searches': "熱門搜尋",
    'Please search': "請輸入您想搜尋的關鍵字",
    'orderSearch': "輸入訂單或產品名稱進行搜尋",

    // 语言
    'Language selection': "語言選擇",

    // menu
    Brand: "品牌",
    Collect: "收藏",
    Manage: "管理",
    Order: "訂單",
    Wallet: "錢包",
    BlindBox: "盲盒",
    MenuGiftCard: "禮品卡",
    // HotSale
    HotSale: "最新消息在熱銷...",
    // tabs"",
    TodaysOffer: "平台優選",
    'Phone': "智慧型手機",
    'Smart Watch': "智慧手錶",
    'Smart bracelet': "智慧手環",

    // gobuy
    'home.gobuy.title': "驚喜正在等著您",
    'home.gobuy.periods': "盲盒輪次",
    'home.gobuy.freeze': "參與倒數計時",
    'home.gobuy.drawing': "開始倒數計時",
    'home.gobuy.buy': "參與",
    'home.gobuy.isbuy': "已參與",
    
    'home.gobuy.jackpot': "獎金池",
    Purse: "錢包",
    Box: "盲盒",
    'GetAPrize': "獲取獎品",
    Discount: "折扣",
    when: "什麼時候",
    points: "積分",
    seconds: "秒",
    // MessageBox
    'MessageBox.Tips': "提示",
    'MessageBox.Confirm': "確認",
    'MessageBox.Cancel': "取消",
    'MessageBox.buy.box': "您確定要購買這個盲盒嗎？",
    // Toast
    'succ': "成功",
    'err': "錯誤",
    'box.succeeds': "購買成功",
    'box.frozen': "已參與",
    'box.issue': "每期只能購買一個盲盒",

    // 商品列表
    filter: "篩選",
    sales: "銷量",
    selfOP: "自營",
    noMore: "沒有更多了",
    brand: "品牌",
    confirm: "確認",
    reset: "重置",
    ComSor: "綜合排序",
    MostPop: "最受歡迎",
    HighLow: "價格從高到低",
    LowHigh: "價格從低到高",
    SalVol: "銷售量",
    NewArr: "新上架",

    // 购物车
    'cart.cart': "購物車",
    'cart.edit': "編輯",
    'cart.done': "完成",
    'home.cart.voucher': "取得優惠券",
    'home.cart.outstock': "缺貨",
    'home.cart.offshelf': "下架",
    'Only': "僅剩",
    'left': "個",
    'Promotion': "促銷",
    'cart.all': "全選",
    'cart.total': "總計",
    'cart.delete': "刪除",
    'cart.checkout': "結帳",

    // 我的
    'Direct': "直接",
    'Indirect': "間接",
    'MyOrders': "我的訂單",
    'ViewAll': "看全部",
    'Unpaid': "待付款",
    'ToShip': "待出貨",
    'ToReceive': "待收貨",
    'ToReview': "待評價",
    // 盲盒
    'MyBlindBox': "盲盒列表",
    'WaitingDraw': "等待抽獎",
    'Opened': "已開啟（領取/退回）",
    // 礼品卡
    'After sale': "售後",
    'GiftCard': "回收記錄",
    'RecycleGiftCard': "回收禮品卡",
    'Verifying': "校驗",
    'Rebuying': "正在回購",
    'Repurchased': "待打款",
    'Paid': "已打款",
    // 常用工具
    'CommonTools': "常用工具",
    'MyWallet': "我的錢包",
    'VirtualOrders': "虛擬訂單",
    'Refunds': "退款",
    'MyFriends': "我的好友",
    'ChatList': "聊天列表",
    'RealNameVerification': "實名認證",
    'MyFavorites': "我的收藏",
    'Addresses': "地址管理",
    'MyReviews': "我的評價",
    'BrowsingHistory': "瀏覽歷史",
    'Promotions': "促銷活動",
    'StoreManagement': "店舖管理",
    'BecomeASeller': "成為賣家",

    // 订单列表
    'SearchPlaceholder': "輸入訂單商品名稱進行搜尋",
    All: "全部",
    OrderNo: "訂單編號",
    items: "件",
    ShippingFee: "運費",
    'Refund in Progress': "退款中",
    'Cancel Order': "取消訂單",
    'Refund': "退款",
    'Track Shipping': "查看物流",
    'Confirm Receipt': "確認收貨",
    'Evaluate': "評價",
    'Delete': "刪除",
    'Pay': "付款",
    'MessageBox.delete.order': "您確定要刪除此訂單嗎？",
    'MessageBox.cancel.order': "您確定要取消此訂單嗎？",
    'MessageBox.receive.order': "此訂單是否已收貨？",
    // 订单详情
    'Order Details': "訂單詳情",
    'Pickup Code': "取貨碼",
    'Complaint': "投訴",
    'After-Sales': "售後",
    'Gift': "禮物",
    'Order Date': "訂單日期",
    'Used voucher worth': "使用的代金券金額",
    'CNY': "人民幣",
    'Payment Method': "支付方式",
    'Total Product Amount': "商品總金額",
    'Shipping Fee': "運費",
    'Amount Paid': "已付款金額",
    'Return': "退貨",
    // 盲盒列表
    'Pending Draw': "待抽獎",
    'Pending Unboxing': "待開啟",
    'Unboxed': "已開啟",
    'Collected': "已領取",
    'Recycled': "已兌現",
    'Unknown': "未知",
    'Claim': "領取",
    'Recycle': "回購",
    'Unbox': "開啟",
    'MessageBox.recycle.box': "您確定要回收此盲盒嗎？",
    // 盲盒详情
    'Mystery Box Details': "盲盒詳情",
    'Unopened': "未開啟",
    'box.opened': "未開啟",
    'Claimed': "已領取",
    'Confirm Claim': "確認領取",
    'MessageBox.pick.box': "您確定要提取此盲盒嗎？",
    // 盲盒提货
    'Please add address': "請新增地址",
    // 礼品卡列表
    'Face Value Total': "面額總額",
    // 礼品卡详情
    'Gift Card Details': "禮品卡詳情",
    'Card number': "卡號",
    'Activation code': "激活碼",
    'Actual recovery price': "實際回收價格",
    // 礼品卡回收
    'Gift Card Recycling': "禮品卡回收",
    'Confirm Recycling': "確認回收",
    'Please enter the card number': "請輸入卡號",
    'Please enter the activation code': "請輸入激活碼",
    'MessageBox.recycle.gift': "您確定要回收此禮品卡嗎？",

    // 我的钱包
    'My Wallet': "我的錢包",
    'Available Balance': "可用餘額",
    'Gift Balance': "赠送餘額",
    'All': "全部",
    'Next event loading': "下一期活动加载中",
    'Frozen Funds': "凍結資金",
    'Recharge': "儲值",
    "can": "可",
    'Withdraw': "提現",
    'Withdrawal Accounts': "提現帳戶",
    // 充值
    'Recharge Details': "儲值詳情",
    'Recharge Order No.': "儲值訂單編號",
    'Recharge Amount': "儲值金額",
    'Creation Time': "創建時間",
    'MessageBox.recharge.pop': "請輸入儲值金額",
    // 付款
    'payment': "付款",
    'Order submitted successfully, please select payment method': "訂單提交成功，請選擇付款方式",
    'Rechargeable card': "可儲值卡",
    'Please enter a hash': "請輸入哈希",
    'Immediate payment': "立即支付",
    'Wait for the file to load': "請等待文件加載",
    // 提现
    'Withdrawal Details': "提現詳情",
    'Withdrawal Amount': "提現金額",
    'Application Time': "申請時間",
    'New Application': "新申請",
    'Payment Password': "支付密碼",
    'New Payment Password': "新支付密碼",
    'Recipient Information': "收款人資訊",
    'Submit': "提交",
    'Add Recipient Account First': "請先新增收款帳戶",
    'Please bind your mobile phone or email first': "請先綁定您的手機或信箱",
    // 设置
    'Account Settings': "帳戶設定",
    'Change Login Password': "修改登入密碼",
    'Change Payment Password': "修改支付密碼",
    'Log Out': "登出",
    'Mobile': "智慧型手機",
    'Verification Code': "驗證碼",
    'Email': "信箱",
    'New Password': "新密碼",
    'Confirm Password': "確認密碼",
    'Modify': "修改",
    'Bind': "綁定",
    ' Mobile': "智慧型手機",
    ' Email': "信箱",
    // 资金详情
    'Fund Details': "資金詳情",
    'Withdrawal Account': "提現帳號",
    'Account Type': "帳戶類型",
    'USDT Address (opBNB)': "USDT-opBNB",
    'Edit': "編輯",
    'Delete': "刪除",
    'Add New': "新增帳號",
    'MessageBox.delete.bank': "您確定要刪除此提現帳號嗎？",
    // 登录
    'Login': "登入",
    'Sign Up': "註冊",
    'Normal Login': "普通登入",
    'Username / Email / Phone Number': "使用者名稱/電子郵件",
    'Enter Phone Number': "請輸入手機號碼",
    'Enter Email': "請輸入電子郵件",
    'Enter SMS Code': "請輸入簡訊驗證碼",
    'Enter Password': "請輸入密碼",
    "enter_login_password_for_verification": "請輸入登入密碼驗證",
    'Forgot Password': "忘記密碼",
    'Third-party Login': "第三方登入",
    'Please complete the form': "請填寫完整的表單",
    'WeChat': "微信",
    'Weibo': "微博",
    'QQ': "QQ",
    'phone login': "手機登入",
    'Login Expired': "登入已過期",
    'Please enter your phone number first': "請先輸入手機號碼",
    'Please enter your username/email/phone number': "請輸入使用者名稱/電子郵件",
    'Please enter your password': "請輸入密碼",
    'Password must be at least 6 characters': "密碼必須至少為 6 個字符",
    'Please enter an 11-digit phone number': "請輸入 11 位手機號碼",
    'Please wait for the file to finish loading': "請等待檔案載入完成",
    'send': "傳送",
    'signUpTips': "您的個人資料將用於支援您在整個網站上的體驗，管理對您帳戶的訪問，以及我們隱私權政策中描述的其他目的。",

    // 注册
    'Sign Up': "註冊",
    'Referrer': "推薦人",
    'Invitation code': "邀請碼",
    'Please.enter.Invitation.code': '請填寫邀請碼',
    'Email.verification.code': '郵箱驗證碼',
    'Invite friends': "邀請好友",
    'Username': "用户名",
    'Full Name': "真實姓名",
    'Set Password': "設定密碼",
    'Confirm Password': "確認密碼",
    'Phone Number': "手機號碼",
    'Email': "電子郵件",
    'Username: 3-25 chars, letters & numbers': "使用者名稱：3-25 個字符，字母和數字",
    '6-20 digits/letters/symbols': "6-20 位數字/字母/符號",
    'By clicking sign up, you agree to': "點擊註冊即表示您同意",
    'User Agreement': "使用者協定",
    'Please check the user agreement': "請檢查用戶協議",
    'Please enter a username with 3-25 characters': "請輸入 3-25 個字元的使用者名",
    'Enter SMS Verification Code': "請輸入簡訊驗證碼",
    'Please enter your phone number': "請輸入您的手機號碼",
    'Please enter the verification code': "請輸入驗證碼",
    'Please enter a 6-digit verification code': "請輸入 6 位元驗證碼",
    'Please enter a password with 6-20 characters': "請輸入 6-20 個字元的密碼",
    'Please enter the confirm password': "請輸入確認密碼",
    'The confirm password does not match the entered password': "確認密碼與輸入的密碼不匹配",

    // 密码恢复
    'Password Recovery': "密碼恢復",
    'Forgot Password': "忘記密碼",
    'Forget.email.tips': "如果您的帳戶尚未與電子郵件號碼關聯，請聯絡平台管理員以恢復您的密碼。",

    // 通知
    'Notification Message': "通知訊息",
    'Direct Message': "私訊",
    'System Message': "系統訊息",
    'Leave a Message': "留言",

    // 配送地址
    'Delivery Address': "配送地址",
    'The store is no longer valid, please edit the delivery address again': "該店家不再有效，請重新編輯配送地址",
    'Default address': "預設位址",
    'Add address': "新增地址",
    'Edit address': "編輯地址",
    'MessageBox.delete.address': "您確定要刪除此地址嗎？",
    'name': "姓名",
    'phone': "手機號",
    'district': "區",
    'address': "地址",
    'default address': "預設位址",
    'save and use': "儲存並使用",
    'save': "儲存",
    'Please select a region': "請選擇地區",
    'Please fill in the recipient name': "請輸入收件人姓名",
    'Name must be 2-15 characters': "姓名必須為 2-15 個字符",
    'Please fill in the mobile phone number': "請輸入手機號碼",
    'Please select your location': "請選擇您的位置",
    'Please fill in the detailed address': "請填寫詳細地址",

    // 浏览历史
    'Browsing History': "瀏覽歷史",
    'Clear browsing history': "清除瀏覽記錄",

    // 推广会员
    'Promotion member': "推廣會員",
    "PromotionPoster": "推廣海報",
    "MemberName": "會員姓名",
    "MyAssets": "我的資產",
    "DistributedAmount": "分配金額",
    "NumberOfDistributedProducts": "分配產品數量",
    "DistributedProductAmount": "分配金額",
    "MyTeam": "我的團隊",
    "LevelOneMembers": "一級成員",
    "LevelTwoMembers": "二級成員",
    "PromotionPoster": "推廣海報",
    "PromotionMembers": "推廣會員",
    "PromotionPerformance": "推廣績效",
    "ViewPromotionLink": "點擊查看推廣連結",
    "PromoteViaWeChatQRCode": "透過微信二維碼推廣",
    "Copy": "複製",
    "BrowserNotSupportedCopyManually": "您的瀏覽器不支援直接複製，請手動複製",
    "GiftCardRecoveryTotal": "禮品卡回收總數",
    "TodaysGiftCardRecoveryCount": "今天的禮品卡回收數量",
    "RegistrationDate": "註冊日期",
    "LastLogin": "最後登入",
    "Promotion Commission": "推廣佣金",

    // userinfo 个人信息
    "Personal Info": "個人資訊",
    "Nickname": "暱稱",
    "Birthdate": "出生日期",
    "Save": "儲存",
    "CropImage": "裁切圖片",
    "UseImage": "使用圖片",

    // goodsDetail 商品详情
    "Off": "折扣",
    "Sold": "已售",
    "Product": "產品",
    "Comment": "評論",
    "Details": "詳情",
    "ReportViolation": "檢舉",
    "Cart": "購物車",
    "ChatMessages": "聊天訊息",
    "MyShop": "我的商店",
    "MerchantLogin": "商家登入",
    "Share": "分享",
    "ShareTo": "分享至",
    "WeChat": "微信",
    "Copy": "複製",
    "Poster": "海報",
    "BrowserNotSupportedCopyManually": "您的瀏覽器不支援直接複製，請手動複製",
    "Follow": "關注",
    "Unfollow": "取消追蹤",
    "PleaseSelectQuantityAndCategory": "請選定數量和類別。",
    "SelectedWithQuantity1": "已選{specification}，數量{number}。",
    "SelectedQuantity1": "已選數量{number}。",
    "SelectedWithQuantity2": "已選{specification}，數量{number}。",
    "Add to cart": "加入購物車",
    "Buy now": "立即購買",
    "Stock": "庫存",
    "Pieces": "件",
    "Quantity": "數量",
    "All": "全部",
    "Good": "好評",
    "Medium": "中評",
    "Bad": "差評",
    // 评论
    "Product review": "商品評論",
    "anonymous": "匿名",
    "noReviewInfo": "沒有提供評論訊息",
    "Shop Owners Response": "店主回應",
    "This product has no current reviews": "該產品目前沒有評論",
    "Product details": "產品詳情",
    "shop": "商店",
    "customerService": "客戶服務",
    "shoppingCart": "購物車",
    "addToCart": "加入購物車",
    "buyNow": "立即購買",
    "outOfStock": "所選商品目前缺貨，抱歉！",
    "notAvailable": "所選產品不再供應，抱歉！",
    "Store order message": "店舖訂單消息",
    "Confirm the order": "確認訂單",
    "productAmount": "產品金額",
    "discount": "折扣",
    "shippingFee": "運費",
    "subtotal": "店鋪小計",
    "Submit an order": "提交訂單",
    // 退货
    "refundAdd": "添加退款",
    "back": "返回",
    "refundDescription": "退款說明：",
    "proofOfRefund": "退款憑證",
    "use": "使用",

    // 一元购
    "yi1": `一元購`,
    "yi2": `價格專區`,
    "yi3": `區`,
    "yi4": `購買記錄`,
    "yi5": `獲得的商品記錄`,
    "yi6": `查看兌換碼`,
    "yi7": `申請提現`,
    "yi8": `我要充值`,
    "yi9": `已參與數量`,
    "yi10": `總數量`,
    "yi11": `欠缺數量`,
    "yi12": `立即購買`,
    "yi13": `繼續購買`,
    "yi14": `其他專區`,
    "yi15": `加載更多`,
    "yi16": `敬請期待...`,
    "yi17": `專區`,
    "yi18": `第`,
    "yi19": `期`,
    "yi20": `價格：`,
    "yi21": `加載更多`,
    "yi22": `快捷支付--您要購買的商品信息`,
    "yi23": `購買數量`,
    "yi24": `（購買數量越多獲得商品機率越大哦）`,
    "yi25": `共計: `,
    "yi26": `支付成功`,
    "yi27": `支付失敗`,
    "yi28": `原因：`,
    "yi29": `揭曉結果`,
    "yi30": `幸運購買碼`,
    "yi31": `商品獲得者`,
    "yi32": `恭喜您獲得本場商品`,
    "yi33": `揭曉時間：`,
    "yi34": `購買時間：`,
    "yi35": `商品獲得者本場總共購買數量: `,
    "yi36": ` 購買碼:`,
    "yi37": `提貨`,
    "yi38": `兌現`,
    "yi39": `預購`,
    "yi40": `購買`,
    "yi41": `獲得的商品記錄`,
    "yi42": `中獎日期：`,

    "hunt1": `兌現碼`,
    "hunt2": `鴻運當頭`,
    "hunt3": `勢不可擋`,
    "hunt4": `兌現碼`,
    "hunt5": `兌換碼：`,
    "hunt6": `加載更多`,
    "hunt7": `我要兌換`,
    "hunt8": `請輸入兌現碼`,
    "hunt9": `兌現價格為售價的9折`,
    "hunt10": `商品列表`,
    "hunt11": `區`,
    "hunt12": `語言`,
    "hunt13": `公告`,
    "hunt14": `導航`,
    "hunt15": `官方公告`,
    "hunt16": `奪寶記錄`,
    "hunt17": `寄貨規則`,
    "hunt18": `規則說明`,
    "hunt19": `我要兌換`,
    "hunt20": `聯繫我們`,
    "hunt21": `郵箱`,
    "hunt22": `開獎規則`,
    "hunt23": `規則概述`,
    "hunt24": `1.號碼分配：`,
    "hunt25": `每支付 0.1 USDT，用戶獲得一個幸運號碼，號碼從 000001 開始按順序分發，直到目標人數達到預定總數（如 1000 人）`,
    "hunt26": `2.開獎條件：`,
    "hunt27": `當商品達到目標參與人數（例如 1000 人次）後，進入開獎流程。`,
    "hunt28": `3.開獎時間：`,
    "hunt29": `在最後一個訂單確認後，等待最近的區塊鏈時間點為 05、10、15、25、30、35、40、45、50、55、整點 的區塊哈希值。`,
    "hunt30": `4.中獎號碼計算：`,
    "hunt31": `1.取區塊哈希值中的純數字，計算其對總參與人數的取模：
                中獎號碼=(哈希值中的純數字%總參與人數)+1`,
    "hunt32": `2.計算結果對應的號碼即為中獎號碼。`,
    "hunt33": `參與階段`,
    "hunt34": `用戶每支付 0.1 USDT，即獲得一個幸運號碼`,
    "hunt35": `商品達到目標參與人數後，停止接收新的參與。`,
    "hunt36": `開獎階段`,
    "hunt37": `確認最後一個訂單時間，記錄具體的時間點（例如 15:47:23）。`,
    "hunt38": `等待最近的區塊鏈區塊生成時間符合規則：`,
    "hunt39": `區塊鏈時間點尾數為 05、10、15、25、30、35、40、45、50、55 或整點（如 15:50:00）`,
    "hunt40": `獲取符合條件的區塊哈希值。`,
    "hunt41": `中獎階段`,
    "hunt42": `從區塊哈希值中提取純數字。`,
    "hunt43": `示例哈希值 0000000000000000000a16b6f44536e521000000adbcf3f4b2ec018ffabcd123`,
    "hunt44": `提取純數字為：16644536521000000342018123`,
    "hunt45": `對總參與人數取模：`,
    "hunt46": `中獎號碼`,
    "hunt47": `=(提取的數字%總參與人數)+1 `,
    "hunt48": `假設提取的數字為 16644536521000000342018123，總參與人數為 1000：`,
    "hunt49": `= (16644536521000000342018123 % 1000) + 1 = 123 + 1 = 124`,
    "hunt50": `公示結果`,
    "hunt51": `平台公佈中獎號碼、對應的用戶信息`,
    "hunt52": `同時提供完整的計算過程（訂單時間、使用的區塊哈希、提取數字及中獎號碼計算公式）`,
    "hunt53": `優勢`,
    "hunt54": `1.公平性`,
    "hunt55": `利用公開的區塊鏈哈希值，開獎結果不可預測、不可篡改。`,
    "hunt56": `2.透明性`,
    "hunt57": `用戶可驗證哈希值和號碼分配過程。`,
    "hunt58": `3.效率高`,
    "hunt59": `只需等待符合條件的區塊生成，快速得出結果。`,
    "hunt60": `公告詳情`,
    "hunt61": `購買份數：`,
    "hunt62": `份`,
    "hunt63": `點擊查看購買碼`,
    "hunt64": `購買碼:`,
    "hunt65": `規則說明`,
    "hunt66": `關於訂單`,
    "hunt67": `為了您儘快收到產品，當天16:00前下單我們將在當天通過XX快遞以及XX快遞發出。如需加急可聯繫客服補差價發順XX快遞，暫不支持指定其他快遞。`,
    "hunt68": `關於發票`,
    "hunt69": `所售產品均可開具電子發票，您可以通過訂單聯繫客服，發送開具發票信息一般情況下1-3日內開出。如果遇到了節假日則往後順延`,
    "hunt70": `幸運購`,

    "new1": "範例",
    "new2": "商品需要 1000 人參與，最後訂單時間為 15:47:23。\n最近符合開獎時間的區塊時間為 15:50:00",
    "new3": "區塊哈希值為：",
    "new4": "提取哈希值中的純數字為：",
    "new5": "計算中獎號碼：",
    "new6": "中獎號碼",
    "new7": "中獎號碼為 124，對應的用戶即為獲獎者。",
    "new8": `已兌現`,
    "new9": `未兌現`,
    "new10": `很遺憾，未中獎`,
    "new11": `恭喜`,
    "new12": `獲得本場商品`,
    "new13": `兌現`,
    "new14": `幸運購`,
    "new15": `已提貨`,

    "new16": "確定要提貨嗎？",
    "new17": "確定要兌現嗎？",
    "copyS": "複製成功",
    "copyE": "複製失敗",
    "new18": "商品展示",
    "new19": "上一頁",
    "new20": "下一頁",
    "new21": "到第",
    "new22": "頁",
    "new23": "確定",
    "new24": "正在等待開獎",

    "tool1": "首頁",
    "tool2": "商品",
    "tool3": "公告",
    "tool4": "奪寶記錄",
    "tool5": "寄貨規則",
    "tool6": "規則說明",
    "tool7": "我要兌換",
    "tool8": "聯繫我們",

    "new25": "商品兌現",
    "new26": "請輸入gobuy使用者名稱",



    "ship1": "適用範圍",
    "ship2": "這些運送規則適用於 luckybuy 電子商務平台上的所有訂單。由於該平台僅接受 USDT 付款，因此不支援信用卡、現金付款或運費扣除。特此制定以下規則。",
    "ship3": "1. 美國境內運送規則",
    "ship4": "付款方式",
    "ship5": "僅接受 USDT 付款。不支援信用卡與現金結算。",
    "ship6": "貨到付款服務",
    "ship7": "貨到付款服務僅適用於美國境內的客戶，無需預先支付運費。",
    "ship8": "運送政策",
    "ship9": "訂單金額不包含運費，運費需另行支付。",
    "ship10": "配送範圍",
    "ship11": "配送範圍涵蓋整個美國本土。",
    "ship12": "客戶須知",
    "ship13": "下單後，客戶需確保聯絡資訊正確無誤。收貨時須由客戶本人或經授權之代理人簽收。",
    "ship14": "2. 美國境外運送規則",
    "ship15": "僅接受 USDT 付款。不支援信用卡與現金結算。",
    "ship16": "美國境外的客戶需在完成訂單付款後，另行支付運費。",
    "ship17": "當額外運費支付完成後，平台將安排出貨。",
    "ship18": "貨到付款政策",
    "ship19": "不提供貨到付款服務。美國境外客戶在訂單處理前必須先完成運費支付。",
    "ship20": "額外運費支付流程",
    "ship21": "訂單完成後，平台會依據客戶地址計算運費並通知客戶以 USDT 方式補足額外費用。",
    "ship22": "當運費支付完成後，平台將安排出貨並提供物流追蹤資訊。",
    "ship23": "配送支援全球所有國家/地區，實際到貨時間視當地物流情況而定。",
    "ship24": "客戶必須確認地址與聯絡資訊的正確性。如因填寫資訊錯誤而導致無法送達，須由客戶自行承擔責任。",
    "ship25": "平台對目的地國家的海關政策不負任何責任。客戶須自行瞭解與辦理清關手續以及可能產生的額外費用。",
    "ship26": "注意事項",
    "ship27": "1. 訂單完成付款後，無法取消或退款。建議客戶在付款前仔細確認訂單資訊。",
    "ship28": "2. luckybuy 對於運輸過程中因不可抗力（如自然災害或政策變更）而產生的問題不負責，但會盡力協助客戶解決。",
    "ship29": "3. 如有任何疑問，請聯繫本平台的客服管道。",
    "ship30": "感謝您的理解與支持！",
    "ship31": "luckybuy 致力為您服務。",

    // 礼品卡相关
    'Original Price':'原價',
    'Actual Payment':'實際付款',
    'Balance':'餘額',
    'MessageBox.buy.card': '您確定要購買這張禮品卡嗎？',
    'MyCard':'我的卡',
    'Please upload pictures':'請上傳圖片',
    'Share audit list':'分享審核列表',
    'Share page':'分享頁面',
    'Audit result':'審核結果',
    'Share to the community':'分享至社區',
    'imshares1':'步驟介紹',
    'imshares2':'步驟 1：在社交媒體上分享產品。',
    'imshares3':'步驟 2：拍攝產品分享頁面的截圖並上傳至GoBuy。',
    'Share Time':'分享時間',
    'Audit status':'審核狀態',
    'Reason for failure':'失敗原因',
    'Pending approval':'待審批',
    'Approved':'已批准',
    'Audit failed':'審核失敗',
    'Url Copied':'連結複製成功，即將跳轉分享...',
    "Points Logs": "積分記錄",
    "My Points": "我的積分",
    "Go Excharge": "前往兌換",
    "Confirm points excharge": "您確定要將所有積分轉換為餘額嗎？",
    'is not share': '您還未完成分享任務',
    'is buied': '您今天已經購買過了',
    'My card': '我的卡片',
    "Country/Region": "國家/地區",
    "Contact info": "聯絡信息",
    "Please enter real name": "請輸入真實姓名",
    "Please enter Phone Number": "請輸入電話號碼",
    "Please enter State/Province/Region": "請輸入州/省/地區",
    "Please enter City": "請輸入城市",
    "Please enter Street Address": "請輸入街道地址",
    "Please enter Postal Code": "請輸入郵政編碼",
    "lucky_draw_winning_products": "抽獎中獎產品",
    "refundAdd": "退款申請",
    "refundDescription": "退款描述",
    "productQualityIssue": "產品質量問題",
    "logisticsTransportIssue": "物流和運輸問題",
    "sellerPlatformIssue": "商家或平台問題",
    "personalReason": "個人原因",
    "otherSpecialCases": "其他特殊情況",
    "hunt points rule": "積分說明",
    "hunt points rule1": "1、積分取得：使用者參與幸運購，每投入 0.1 美元即可獲得 1 積分",
    "hunt points rule2": "2、積分兌換：1 積分 = 0.01% 美元",
    'Login Password': "登入密碼",
    "Level": "等级",
    //新手指南
    "guide.Rewards": "獎勵介紹",
    "guide.title": "新手指南",
    "guide.Invitation.Reward": "活動獎勵",
    "guide.Order.Sharing": "曬單分享",
    "guide.section1.title": "幸運購買指南",
    "guide.section1.step1": "選擇購買：進入美元專區，挑選心儀商品。",
    "guide.section1.step2": "選擇份數：輸入您想參與的購買份數。",
    "guide.section1.step3": "购买份数：购买1份数量只需支付0.1美元。",
    "guide.section1.step4": "等待開獎：系統自動抽出幸運獲獎者。",
    "guide.section2.title": "盲盒購買指南",
    "guide.section2.step1": "開啟盲盒：點擊進入盲盒專區。",
    "guide.section2.step2": "立即參與：支付 1 美元。",
    "guide.section2.step3": "揭曉獎品：贏取價值高達 300 萬美元。",
    "guide.section3.title": "禮品卡購買指南",
    "guide.section3.step1": "分享社群：立即分享活動並上傳資訊。",
    "guide.section3.step2": "選擇面額：自由挑選禮品卡價格。",
    "guide.section3.step3": "如购买100礼品卡只需支付98美元。",
    "guide.section3.step4": "立即回購：回購100%，賺取2美元",
    "guide.tip.title": "溫馨提示：超值福利不容錯過",
    "guide.tip.luckyBuy": "僅需 0.1美元 參與，有機會贏取 1美元至50,000美元 的獎品！",
    "guide.tip.luckyBuy1": "團隊返傭獎勵：邀請好友購買，最高享 0.2% 返傭！",
    "guide.tip.luckyBuy2": "積分兌換：每購買1份幸運購，累積1積分，1000積分=0.1美元！",
    "guide.tip.example": "範例：",
    "guide.tip.example1": "您邀請用戶A，A購買1000美元 → 您獲得 2美元 返傭。",
    "guide.tip.example11": "A邀請用戶B，B購買1000美元 → 您再獲得 1美元 返傭。",
    "guide.tip.boxTitle": "盲盒抽獎",
    "guide.tip.box": "1美元 參與一次，獎品價值高達 300萬美元！",
    "guide.tip.cardTitle": "禮品卡",
    "guide.tip.card": "團隊返傭：邀請好友購買，最高享 0.4% 返傭！",
    "guide.tip.example2": "當您邀請A用戶購買禮品卡100美元，您將獲得返傭0.4美元",
    "guide.tip.example3": "A邀請用戶B，B購買100美元禮品卡 → 您再獲得 0.2美元",
    "guide.tip.callToAction": "立即參與，開啟您的幸運之旅！",
    "guide.warning.title": "溫馨提醒",
    "guide.warning.rule1": "哪些情況會導致傭金失效？",
    "guide.warning.answer1": "借助軟體及其他平台，惡意獲取傭金，一經查實，扣除一切傭金且封號。",
    "guide.warning.rule2": "自己邀請自己也能獲得傭金嗎？",
    "guide.warning.answer2": "不可以。我們會人工核查，對於查實的作弊行為，扣除一切傭金，取消邀請傭金的資格並清除您的帳戶。",
    "invite.title": "福利來襲｜邀請好友狂賺4重大獎",
    "invite.reward1.title": "獎勵一：拉人進群，輕鬆賺美金 + 禮品卡",
    "invite.reward1.item1": "每成功邀請10位新成員進群，立享搶紅包獎勵！",
    "invite.reward1.item2": "同時送出1美元禮品卡",
    "invite.reward1.item3": "拉得越多，獎勵越多！紅包秒發，禮品卡現兌！",
    "invite.reward2.title": "獎勵二：幸運購，躺著也能賺傭金",
    "invite.reward2.item1": "好友每參與一次幸運購活動，你都能獲得傭金返傭！",
    "invite.reward2.item2": "傭金無限上限，買得多=你賺得多！",
    "invite.reward3.title": "獎勵三：禮品卡",
    "invite.reward3.item1": "好友成功購買任意禮品卡，你將立即獲得傭金返利！",
    "invite.reward3.item2": "零成本分享連結，自動追蹤，操作超簡單：",
    "invite.reward3.item3": "發連結 → 好友下單 → 坐等到帳！",
    "invite.callToAction": "趕快邀請好友入群，把福利通通帶回家！讓我們一起邊玩邊賺錢！",
    "share.title": "GoBuy 中獎分享贏 1 美元禮品卡",
    "share.subtitle": "分享標題",
    "share.content1": "感謝 GoBuy 幸運購物帶來的好運，我們的一位會員今天進行了一筆小額投資，贏得了獎品，並成功提現！✨",
    "share.content2": "現在輪到您了！只需分享您的中獎體驗，即可獲贈 GoBuy 的 1 美元免費禮品卡！不要錯過——簡單、獎勵豐富、樂趣無窮！",
    "share.inviteLink": "附件您的邀請連結碼：",
    "share.stepsTitle": "參與方式：",
    "share.step1": "在幸運購買區上傳您的代碼購買/訂單的螢幕截圖",
    "share.step2": "上傳“恭喜，您中獎了！”消息的螢幕截圖",
    "share.step3": "上傳您的提現申請和交易成功的螢幕截圖",
    "share.step4": "完成以上步驟後，將您在社交媒體分享的截圖發送給客服團隊驗證",
    "share.email": "客服支援信箱：",
    "share.footer": "讓好運伴您左右——繼續玩，繼續贏！GoBuy——讓購物每天都充滿樂趣和回報！",
    "doubleBet.title": "倍投出奇蹟｜簡單3步，逆襲贏大獎！",
    "doubleBet.step1": "第1輪選擇1美元區，購買0.5美元，購買5份數量，若中獎，立即止盈。",
    "doubleBet.step2": "若未中獎，第2輪選擇為3美元區，購買1.5美元，購買15份數量，若中獎，立即止盈。",
    "doubleBet.step3": "若仍未中獎，第3輪選擇8美元區；購買4美元，購買40份數量，恭喜中獎。",
    "doubleBet.step4": "中獎後，即可覆蓋前兩輪損失並獲利，重新回到第1輪開始。",
    "invite.reward4.title": "獎勳4：限時福利活動｜新手專屬好禮",
    "invite.reward4.step1": "免費參與 1 次幸運購",
    "invite.reward4.step2": "免費開啟 1 次盲盒抽獎",
    "invite.reward4.step3": "完成指定任務，額外獲得 1 美元現金獎勳",
    "reward.register.title": "註冊獎勵",
    "reward.register.point1": "新用戶註冊即可獲得一次免費參與幸運購的機會。",
    "reward.register.point2": "完成註冊並加入群組即可參加紅包活動。",
    "reward.task.title": "任務獎勵",
    "reward.task.point1": "以訪客身份登入，完成一次盲盒抽獎。",
    "reward.task.point2": "完成以下三項幸運購體驗任務，每個區域僅需參與一次：",
    "reward.task.subtask1": "1 美元專區體驗一次，購買 0.5 美元",
    "reward.task.subtask2": "3 美元專區體驗一次，購買 1.5 美元",
    "reward.task.subtask3": "8 美元專區體驗一次，購買 4 美元",
    "reward.task.point3": "完成上述兩項任務，即可領取 1 美元活動獎勵！",
    "reward.share.title": "分享獎勵",
    "reward.share.desc": "我剛剛在 GoBuy 上贏得了一個驚喜盲盒和一次幸運抽獎！",
    "reward.share.desc3": "註冊後我馬上就幸運中獎了——太棒了！",
    "reward.share.desc4": "✨成功分享中獎截圖即可獲得 1 美元獎勵。",
    "reward.share.desc1": "邀請 10 位好友並完成註冊即可獲得 1 美元，邀請 1000 位可得 100 美元獎勵，無上限，邀請越多獎勵越多",
    "reward.invite.title": "邀請獎勵",
    "reward.share.desc2": "完成以上任務，即可領取分享獎勵和邀請獎勵！",
    "reward.invite.desc1": "完成以上任務，即可領取邀請活動獎勵！",

    "account.bank": "銀行",
    "account.name": "帳戶名稱",
    "bank.name": "銀行名稱",
    "account.number": "帳號",
    "account.ifsc": "IFSC代碼",
    "account.type": "帳戶類型",
    "bank.upi.code": "UPI代碼",
    "bank.upi": "UPI掃碼",
    "save.img.save": "長按上方圖片以儲存",
    "bank.pay.tip": "提示：請在轉帳時準確輸入對應的INR金額，否則系統將無法自動識別入帳",
    "bank.upi.order": "UPI交易ID／交易參考號",
    "Please enter a upi order": "請輸入UPI交易ID／交易參考號",
    



    "guide.title": "使用指南",
    "guide.section1.title": "幸運購",
    "guide.section1.step1": "💲 0.1 美元 = 1 次參與",
    "guide.section1.step2": "🍀 系統隨機開獎 → 贏取 $1–$50,000",

    "guide.section2.title": "盲盒",
    "guide.section2.step1": "💲 1 美元 = 本期購買 1 次機會",
    "guide.section2.step2": "🎉 最高可贏 300 萬美元大獎",

    "guide.section3.title": "禮品卡",
    "guide.section3.step1": "💲 98 美元 = 100 美元禮品卡",
    "guide.section3.step2": "💰 系統回購 → 利潤賺 $2",

    "guide.Invitation.Reward": "邀請獎勵",
    "reward.register.title": "註冊獎勵",
    "reward.register.point1": "新用戶註冊 → 🎟️ 獲得 1 次幸運購機會",
    "reward.register.point2": "平台自動贈送，無需申請",

    "reward.recharge.title": "首充獎勵",
    "reward.recharge.point1": "🆕 新用戶首次充值 → 🎁 獲得 $2 獎勵",
    "reward.recharge.point2": "📩 客服郵箱：gobuyusa888@gmail.com",
    "reward.task.point3": "完成任務可解鎖更多獎勵",

    "reward.invite.title": "邀請好友獎勵",
    "reward.invite.point1": "邀請好友完成充值 → 🎁 獲得 $1 獎勵",
    "reward.invite.point2": "無上限，邀請越多，獎勵越多！",
    "reward.invite.point3": "平台自動贈送，無需申請",

    "share.rewardTitle": "分享獎勵",
    "share.rewardStep1": "分享您的幸運購 / 盲盒 / 禮品卡開獎截圖到社群",
    "share.rewardStep2": "分享一次 = 獎勵 $1",
    "share.rewardStep3": "每個用戶限領一次",
    "share.contact": "客服郵箱",
    "share.email": "請發送郵件至 gobuyusavip@gmail.com",

    "share.guestTitle": "遊客任務獎勵",
    "share.guestStep1": "完成以下 2 個任務：",
    "share.guestStep2": "1️⃣ 購買 1 次幸運購",
    "share.guestStep3": "2️⃣ 購買 3 次盲盒",
    "share.guestStep4": "⚠️ 每個用戶限領 1 次",
    "share.guestContact": "客服郵箱：gobuyusa888@gmail.com",

    "share.teamTitle": "團隊獎勵",
    "share.teamStep1": "🔗 通過您的邀請鏈接註冊的用戶 = 您的團隊成員",
    "share.teamStep2": "🏆 獎勵規則：",
    "share.teamStep3": "• 邀請 10 位活躍成員 → 獎勵 $1",
    "share.teamStep4": "• 邀請 1000 位活躍成員 → 獎勵 $100",
    "share.teamNote": "⚠️ 活躍會員 = 註冊並充值後至少完成一次購買（禮品卡 / 盲盒 / 幸運購）的用戶。",
    "share.teamContact": "客服郵箱：gobuyusa888@gmail.com",


    "guest.rewardTitle": "游客任务奖励",
    "guest.intro": "完成以下 2 个任务：",
    "guest.task1": "购买 1 次盲盒",
    "guest.task2": "购买 3 次幸运购",
    "guest.limit": "每个用户限领 1 次",

    "team.rewardTitle": "团队奖励",
    "team.ruleIntro": "通过您的邀请链接注册的用户 = 您的团队成员",
    "team.ruleTitle": "奖励规则：",
    "team.rule1": "邀请 10 位有效成员 → 奖励 $1",
    "team.rule2": "邀请 1000 位有效成员 → 奖励 $100",
    "team.note": "活跃会员 = 注册并充值后至少完成一次购买（礼品卡/神秘盒子/幸运购买）的用户。",
    "reward.firstCharge.title": "首充奖励",
    "reward.firstCharge.point1": "新用户首次充值 → 🎁 获得 $2 奖励",
}
export default TW
